/**
 * @author zjc[beica1@outook.com]
 * @date 2021/9/7 10:47
 * @description
 *   config.js of wetrade.www
 */
const isDevMode = () => process.env.NODE_ENV === 'development'

export default {
  server: isDevMode() ? {
    api: 'http://wetrade-web-api.thebestdeveloperever.com',
    // api: 'https://pc-api.wetrade.one/',
  } : {
    api: 'https://pc-api.wetrade.one/',
  }
}



// WEBPACK FOOTER //
// ./src/config.js